import { hasMessageAttribute, orderMessages } from 'modules/message/utils'
import { isEmpty, pathOr, values } from 'ramda'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Message } from 'types/message'

const useUnreadMessagesForActiveConversation = (): Message[] => {
  const { activeConversation } = useSelector(state =>
    state.conversations
  )

  const messagesForConversation = useSelector(state =>
    pathOr({}, ['conversations', 'messages', activeConversation], state)
  )

  const unreadMessageIdsForConversation = useSelector(state =>
    pathOr([], ['conversations', 'unreadAgentMessages', activeConversation], state)
  )

  const availableUnreadMessages = useMemo(() => {
    if (isEmpty(messagesForConversation)) {
      return []
    }

    const messageValues = orderMessages(values(messagesForConversation))

    const messageHasBody = (message: Message) => !!message.body && !!message.body.length
    const messageIsNotRatingPrompt = (message: Message) =>  !hasMessageAttribute(message, 'ratingPrompt')
    const messageIsUnread = (message: Message) => unreadMessageIdsForConversation.includes(message.id)

    return messageValues
          .filter(message =>
            messageHasBody(message) &&
            messageIsNotRatingPrompt(message) &&
            messageIsUnread(message))
  }, [messagesForConversation, unreadMessageIdsForConversation])

  return availableUnreadMessages
}

export default useUnreadMessagesForActiveConversation
